import PhoneInput from 'react-phone-input-2'

interface Props {
    country?: string
    value: string
    onChange?: (value: string) => void
    disabled?: boolean
}

const CustomPhoneInput = ({ country = 'ar', value, onChange, disabled }: Props) => {
    return (
        <PhoneInput
            country={country}
            value={value}
            onChange={(e) => {
                if (onChange) onChange(e)
            }}
            inputStyle={{
                height: '56.7px',
                paddingLeft: '55px',
                width: '100%',
            }}
            buttonStyle={{
                height: '56.7px',
            }}
            disabled={disabled}
            enableLongNumbers
        />
    )
}

export default CustomPhoneInput
